import { useQuery } from "@tanstack/react-query";
import { getResearchSession, listResearchSessions } from "@/lib/api";
import { queryKeys } from "@/lib/cache/queryKeys";

export function useResearchSessions() {
  return useQuery({
    queryKey: queryKeys.researchSessions.all,
    queryFn: listResearchSessions,
    staleTime: 15_000,
  });
}

export function useResearchSession(id) {
  return useQuery({
    queryKey: queryKeys.researchSessions.detail(id),
    queryFn: () => getResearchSession(id),
    enabled: Boolean(id),
    staleTime: 15_000,
  });
}
